export default
{
  "ps67lines": [
    "אֱלֹהִים יְחָנֵּנוּ וִיבָרְכֵנוּ יָאֵר־פָּנָיו אִתָּנוּ סֶלָה",
    "לָדַעַת בָּאָרֶץ דַּרְכֶּךָ בְּכָל־גּוֹיִם יְשׁוּעָתֶךָ",
    "יוֹדוּךָ עַמִּים אֱלֹהִים יוֹדוּךָ עַמִּים כֻּלָּם",
    "יִשְׂמְחוּ וִירַנְּנוּ לְאֻמִּים כִּי־תִשְׁפֹּט עַמִּים מִישׁוֹר וּלְאֻמִּים בָּאָרֶץ תַּנחֵם סֶלָה",
    "יוֹדוּךָ עַמִּים אֱלֹהִים יוֹדוּךָ עַמִּים כֻּלָּם",
    "אֶרֶץ נָתְנָה יְבוּלָהּ יְבָרְכֵנוּ אֱלֹהִים אֱלֹהֵינוּ",
    "יְבָרְכֵנוּ אֱלֹהִים וְיִירְאוּ אוֹתוֹ כָּל־אַפְסֵי־אָרֶץ"
  ],
  "lamnatzeachLetters": "ישמחווירננולאמיםכיתשפוטעמיםמישורולאמיםבארץתנחםסלה",
  "anaBekoach": [
    "אָנָּא",
    "בְּכֹחַ",
    "גְּדֻלַּת",
    "יְמִינְךָ",
    "תַּתִּיר",
    "צְרוּרָה",
    "אב״ג ית״ץ",

    "קַבֵּל",
    "רִנַּת",
    "עַמְּךָ",
    "שַׂגְּבֵנוּ",
    "טַהֲרֵנוּ",
    "נוֹרָא",
    "קר״ע שט״ן",

    "נָא",
    "גִבּוֹר",
    "דּוֹרְשֵׁי",
    "יִחוּדְךָ",
    "כְּבָבַת",
    "שָׁמְרֵם",
    "נג״ד יכ״ש",

    "בָּרְכֵם",
    "טַהֲרֵם",
    "רַחֲמֵי",
    "צִדְקָתְךָ",
    "תָּמִיד",
    "גָּמְלֵם",
    "בט״ר צת״ג",

    "חֲסִין",
    "קָדוֹשׁ",
    "בְּרֹב",
    "טוּבְךָ",
    "נַהֵל",
    "עֲדָתֶךָ",
    "חק״ב תנ״ע",

    "יָחִיד",
    "גֵּאֶה",
    "לְעַמְּךָ",
    "פְּנֵה",
    "זוֹכְרֵי",
    "קְדֻשָּׁתֶךָ",
    "יג״ל פז״ק",

    "שַׁוְעָתֵנוּ",
    "קַבֵּל",
    "וּשְׁמַע",
    "צַעֲקָתֵנוּ",
    "יוֹדֵעַ",
    "תַּעֲלוּמוֹת",
    "שק״ו צי״ת"
  ]
}
